import { render } from "./close.vue?vue&type=template&id=2cd1acc5"
import script from "./close.vue?vue&type=script&lang=js"
export * from "./close.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"assets/icons/close.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cd1acc5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cd1acc5', __exports__)) {
    api.reload('2cd1acc5', __exports__)
  }
  
  module.hot.accept("./close.vue?vue&type=template&id=2cd1acc5", () => {
    api.rerender('2cd1acc5', render)
  })

}


export default __exports__